import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Image from '../../../Core/Image';

const mobileL = 425;
// * background color wrapper
export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: ${({ colourOverrideBackground }) => colourOverrideBackground || themeGet('colors.primary')};
`;

// * grid
export const StyledContainer = styled(Container)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0;

  ${Wrapper}.simple.extra-top-padding & {
    padding-top: 150px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 50px 45px 0;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 70px 85px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-evenly;
    align-items: flex-end;
    padding: 0;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    //padding: 70px 45px 0;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.max')}) {
    //padding: 70px 90px 0;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  max-width: 425px;
  margin-top: 20px;
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 500px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-width: 548px;
  }
`;

export const OptionalImage = styled(Image)`
  width: 100%;
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1,
  h2,
  h3,
  p {
    color: ${themeGet('colors.text-primary')};
    /* for IE */
    width: 100%;
    ${Wrapper}.curriculum & {
      color: ${themeGet('colors.text-secondary')};
    }
    ${Wrapper}.curriculum[id$="simpleBannerPrimary"] & {
      margin-bottom: 10px;
    }
    ${Wrapper}.simple.curriculum &, ${Wrapper}.our-mission.curriculum & {
      color: ${themeGet('colors.text-primary')};
    }
  }
  h1,
  h2,
  h3 {
    padding-bottom: 30px;
    &:nth-child(2n) {
      font-weight: 600;
      padding-bottom: 0;
    }
  }
  p {
    text-align: center;
    padding-bottom: 0px;
    letter-spacing: 0;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 20px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 26px;
      text-align: left;
    }
    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      font-weight: 600;
      letter-spacing: -0.42px;
      line-height: 32px;
    }
  }
  a,
  button {
    margin-top: 30px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 500px;
    min-width: 275px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    // padding-bottom: 30px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* for IE */
  width: 100%;
  text-align: center;
  @media only screen and (max-width: 767px) {
    margin: 0 auto;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    text-align: left;
  }
`;
export const PrefineryWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 570px;

  @media only screen and (min-width: ${mobileL}px) {
    min-height: 500px;
    max-height: 540px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    min-height: 470px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    min-width: 400px;
    min-height: 525px;
    max-height: 540px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-self: center;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    min-width: 550px;
  }
`;
export const Prefinery = styled.div`
  display: flex;
  flex-direction: column;
  align-slef: flex-end;
`;
